import { emitCartActionEvent, emitPurchaseEvent, purchase, setItems, updateItemQuantity, } from './cart-actions.js';
import { cartReducer as cart } from './cart-slice.js';
/**
 * Loads the commerce cart reducer and returns the available cart action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the cart action creators.
 *
 * @group Actions
 * @category Cart
 */
export function loadCartActions(engine) {
    engine.addReducers({ cart });
    return {
        emitPurchaseEvent,
        emitCartActionEvent,
        purchase,
        setItems,
        updateItemQuantity,
    };
}
